import { render, staticRenderFns } from "./newAction.vue?vue&type=template&id=113fbd50&scoped=true"
import script from "./newAction.vue?vue&type=script&lang=js"
export * from "./newAction.vue?vue&type=script&lang=js"
import style0 from "./newAction.vue?vue&type=style&index=0&id=113fbd50&prod&lang=scss&scoped=true"
import style1 from "./newAction.vue?vue&type=style&index=1&id=113fbd50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113fbd50",
  null
  
)

export default component.exports